/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

// Absolute import
import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import bootstrap from 'bootstrap/dist/css/bootstrap.css';

// Relative import
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import {
  localStorageGet,
  localStorageRemove,
} from '../../../service/localStorage';
import s from '../Order.sass';
import {
  setOrderVehicleType,
  updateOrderDetailInfoAction,
} from '../../../actions/order';
import orderInit from '../../../ctrl/orderInti.json';

class Order01SelectVehicle extends React.Component {
  static propTypes = {
    currentLocale: PropTypes.string.isRequired,
    setOrderVehicleType: PropTypes.func.isRequired,
    modelDataText: PropTypes.shape().isRequired,
    modelData: PropTypes.shape().isRequired,
    updateOrderDetailInfoAction: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      selectedVehicle: '',
      lang: props.currentLocale.split('-')[1].toLowerCase(),
    };
    this.onClickSelectVehicle = this.onClickSelectVehicle.bind(this);
  }

  componentDidMount() {
    // get selectedVehicle, then remove this in localStorage
    if (localStorageGet('selectedVehicle', false) !== null) {
      this.onClickSelectVehicle(localStorageGet('selectedVehicle', false));
    } else {
      this.onClickSelectVehicle(
        this.props.modelData.vehicle_type.types[0].type,
      );
    }
  }

  // ensure remove selectVehicle in localStorage
  componentWillUnmount() {
    localStorageRemove('selectedVehicle');
  }

  onClickSelectVehicle(type) {
    this.props.setOrderVehicleType(type);
    this.setState({ selectedVehicle: type });
    this.props.updateOrderDetailInfoAction('vehicle', null, type);
    if (this.state.lang === 'hk') {
      this.props.updateOrderDetailInfoAction(
        'order_request_detail_attributes',
        null,
        orderInit.orderDetailInfo[this.state.lang]
          .order_request_detail_attributes,
      );
    }
  }

  render() {
    return (
      <div>
        <div className={s.orderSmallTitle}>
          {this.props.modelDataText.order.order_vehicle_title}
        </div>
        <Row>
          {this.props.modelData.vehicle_type.types.map((obj, index) => {
            const img = obj.icon.toString();
            let img1 = img.split(',')[0].split(' ')[0];
            img1 = img1
              .split('/')
              .reverse()[0]
              .split('.')[0];
            const imgBlueVehicle = require(`../../../assets/src/src_img/${img1}.png`);
            const imgBlueVehicle2 = require(`../../../assets/src/src_img/${img1}@2x.png`);
            return (
              <Col xs="12" sm="12" md="4" key={index.toString()}>
                <div
                  className={`${
                    this.state.selectedVehicle === obj.type
                      ? s.vehicleGridActive
                      : [s.vehicleGrid, s.selectVehicle].join(' ')
                  }`}
                  role="button"
                  tabIndex={0}
                  onClick={() => {
                    this.onClickSelectVehicle(obj.type);
                  }}
                  onKeyPress={() => {}}
                >
                  <Row>
                    <Col md="12" xs="3">
                      <img
                        width="72"
                        height="72"
                        alt={obj.title}
                        srcSet={`${imgBlueVehicle} 1x, ${imgBlueVehicle2} 2x`}
                      />
                      <br />
                      <br />
                    </Col>
                    <Col md="12">
                      <span
                        dangerouslySetInnerHTML={{ __html: obj.title }}
                        style={{ color: '#0088bf' }}
                      />
                    </Col>
                  </Row>
                </div>
              </Col>
            );
          })}
        </Row>
      </div>
    );
  }
}

const mapState = state => ({
  isToggleOn: state.order.isToggleOn,
  currentLocale: state.intl.locale,
});

const mapDispatch = {
  setOrderVehicleType,
  updateOrderDetailInfoAction,
};

export default connect(mapState, mapDispatch)(
  withStyles(bootstrap, s)(Order01SelectVehicle),
);



// WEBPACK FOOTER //
// ./src/routes/order/Order01SelectVehicle/Order01SelectVehicle.js